angular.module('app.routes').run(($rootScope, $state, $stateParams, $localStorage, $timeout, $log, $window, UserService) => {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.breadcrumbs = [];

    $rootScope.$on('$stateChangeSuccess', (event, toState) => {
        // scroll view to top
        $('html, body').animate(
            {
                scrollTop: 0,
            },
            200
        );

        $timeout(() => {
            $rootScope.pageLoading = false;
            $rootScope.pageLoaded = true;

            $('[data-inputmask]').inputmask({});
            $.UIkit.rebuild();

            $($window).resize();
        }, 500);

        // breadcrumbs
        const breadcrumbs = [];
        let state = toState;
        let safe = 20;
        while (state && 'object' === typeof state.data && 0 < safe--) {
            if (UserService.isAllowed(state.data.permissions || {})) {
                breadcrumbs.push({
                    link: state.name,
                    label: state.data.pageTitle,
                });
            }

            state = $state.get(state.data.parent);
        }
        breadcrumbs.push({
            link: 'restricted.dashboard_main',
            label: 'dashboard',
        });

        $timeout(() => {
            $rootScope.breadcrumbs = breadcrumbs.reverse();
        });

        // hashe dla tabów
        jQuery('body')
            .off('click')
            .on('click', '.uk-tab-link a', (e) => {
                const hash = jQuery(e.currentTarget).data('hash') || '';
                $localStorage.lastTab = `${$state.current.name}:${hash}`;
                $log.debug('last tab', $localStorage.lastTab);
            });

        // przełączanie tabów zgodnie z hashem
        if ($localStorage.lastTab) {
            $timeout(() => {
                const tab = ($localStorage.lastTab || '').split(':');
                $log.debug('try to restore last tab', $localStorage.lastTab);
                if (tab[0] == $state.current.name && tab[1]) {
                    const selector = `a[data-hash="${tab[1]}"]`;
                    const link = jQuery(selector);

                    if (link.length && link.is(':visible')) {
                        link.trigger('click');
                    }
                }
            }, 2000);
        }
    });

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
        const isAuthenticated = UserService.isAuthenticated();

        if (isAuthenticated && 'login' === toState.name) {
            event.preventDefault();
            $rootScope.referenceState = fromState;
            $rootScope.referenceStateParams = fromParams;
            $state.go('check-session');

            return false;
        } else if (!isAuthenticated && 'login' !== toState.name && 'check-session' !== toState.name) {
            event.preventDefault();
            $rootScope.referenceState = toState;
            $rootScope.referenceStateParams = toParams;
            $state.go('check-session');

            return false;
        }

        // main search
        $rootScope.mainSearchActive = false;
        // single card
        $rootScope.headerDoubleHeightActive = false;
        // top bar
        $rootScope.topBarActive = false;
        // top menu
        $rootScope.topMenuActive = false;
        // full header
        $rootScope.fullHeaderActive = false;
        // full height
        $rootScope.page_full_height = false;
        // secondary sidebar
        $rootScope.sidebar_secondary = false;
        $rootScope.secondarySidebarHiddenLarge = false;
        // active link (wszelkie akcje edit kierują na listę)
        $rootScope.activeAsideLink = toState.name.replace('_edit', '');

        if ($($window).width() < 1220) {
            $rootScope.primarySidebarActive = false;
            $rootScope.hide_content_sidebar = false;
        }

        $rootScope.pageLoading = true;
        $rootScope.pageLoaded = false;
    });
});
